var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgs-item"},[_c('p',{staticClass:"vertical-letter"},[_c('span',[_vm._v(_vm._s(_vm.tab))])]),_c('div',{staticClass:"imgs-item-content"},_vm._l((_vm.imgList),function(item,idx){return _c('router-link',{key:item.ThumbnailURL,attrs:{"to":{
                name: 'IMAGE_DETAIL',
                query: {
                    sername: _vm.carSeriesInfo.name,
                    tab: _vm.tab,
                    index: item.ImageIndexNumber - 1
                },
                params: {
                    serid: _vm.carSeriesInfo.id
                }
            },"target":"_blank"}},[_c('img',{directives:[{name:"real-src",rawName:"v-real-src",value:(item.ThumbnailURL),expression:"item.ThumbnailURL"}],key:item.ThumbnailURL,attrs:{"src":require("@/assets/images/bitmap-small.png")},on:{"click":function($event){return _vm.logImgClick(_vm.tab, idx)}}})])}),1),_c('router-link',{staticClass:"vertical-letter vertical-letter-icon more",attrs:{"to":{
            name: 'IMAGE_DETAIL',
            query: {
                sername: _vm.carSeriesInfo.name,
                tab: _vm.tab
            },
            params: {
                serid: _vm.carSeriesInfo.id
            }
        },"target":"_blank"},on:{"click":function($event){return this.logImgClick('更多')}}},[_c('span',[_vm._v("更多")]),_c('img',{attrs:{"src":require("@/common/images/car-train/right-arrow-2.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }